let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a08Vk")).then(() => parcelRequire('h3IRN'));